export default __webpack_public_path__ + "static/media/step3.92424a32.png";